export const navMenuItemsData = ref<INavMenuItems[]>([
	{
		label: 'Strona główna',
		icon: 'home',
		route: '/panel',
	},
	{
		label: 'Zakupy',
		icon: 'diets',
		key: 'purchases',
		route: '/panel/purchases',
		items: [
			{
				label: 'Zlecenia zakupowe',
				route: '/panel/purchase-orders',
			},
		],
	},
	{
		label: 'Dostawcy',
		icon: 'delivery',
		route: '/panel/suppliers/list',
	},
	{
		label: 'Magazyn i dostawy',
		icon: 'delivery',
		key: 'expected-deliveries',
		items: [
			{
				label: 'Dostawy i przyjęcia',
				icon: 'diets',
				hideIconInMenu: true,
				route: '/panel/purchases/deliveries',
			},
			{
				label: 'Lokalizacja buforowa',
				icon: 'delivery',
				hideIconInMenu: true,
				route: '/panel/inbound-buffer',
			},
			{
				label: 'Monitoring',
				icon: 'status',
				hideIconInMenu: true,
				route: '/panel/monitoring',
			},
			// {
			// 	label: 'Stan magazynowy',
			// 	route: '/panel/warehouse-deliveries',
			// },
		],
	},
	{
		label: 'Produkcja',
		icon: 'points',
		key: 'production',
		items: [
			{
				label: 'Zlecenia produkcyjne',
				icon: 'points',
				route: '/panel/production-orders',
			},
			{
				label: 'Plany produkcyjne',
				icon: 'points',
				route: '/panel/production-plans',
			},
			{
				label: 'Raporty',
				icon: 'points',
				route: '/panel/production-plans/reports',
			},
			{
				label: 'Gniazda produkcyjne',
				icon: 'settings',
				route: '/panel/production-sockets',
			},
			{
				label: 'Instrukcje',
				icon: 'points',
				route: '/panel/tablet/instructions',
			},
			{
				label: 'Błędy produkcyjne',
				icon: 'points',
				route: '/panel/production-errors',
			},
			{
				label: 'Kompletacja',
				icon: 'settings',
				route: '/panel/production-order-fulfillment',
			},
		],
	},
	{
		label: 'Ustawienia',
		icon: 'settings',
		key: 'employees',
		items: [
			{
				label: 'Jednostki produkcyjne',
				route: '/panel/production-units',
			},
			{
				label: 'Pracownicy produkcji',
				route: '/panel/production-employees/list',
			},
			{
				label: 'Konta użytkowników',
				route: '/panel/employees/list',
			},
			{
				label: 'Magazyn',
				route: '/panel/warehouse',
			},
			{
				label: 'Gniazda receptur',
				route: '/panel/recipe-sockets',
			},
			{
				label: 'Etykiety',
				route: '/panel/labels',
			},
		],
	},
])

interface IRoute {
	route: string
	permissions: EEmployeePermission[] | null
}

// to restrict view for panel routes
export const restrictViewRoutes: IRoute[] = [
	// Zakupy
	{ route: '/panel/purchases', permissions: [EEmployeePermission.VIEW_PURCHASE] },
	{ route: '/panel/purchase-orders', permissions: [EEmployeePermission.VIEW_PURCHASE_ORDER] },

	// Dostawcy
	{ route: '/panel/suppliers/list', permissions: [EEmployeePermission.VIEW_SUPPLIERS] },

	// Produkcja
	{ route: '/panel/production-orders', permissions: [EEmployeePermission.VIEW_PRODUCTION_HALL_LIVE] },
	{ route: '/panel/production-plans/reports', permissions: [EEmployeePermission.EXPORT_REPORTS] },
	{ route: '/panel/production-plans', permissions: [EEmployeePermission.VIEW_SEMI_PRODUCT_DETAILS] },
	{ route: '/panel/production-sockets', permissions: [EEmployeePermission.VIEW_PRODUCTION_SOCKETS] },
	{ route: '/panel/production-errors', permissions: [EEmployeePermission.VIEW_PRODUCTION_HALL_LIVE] },

	// Magazyn i dostawy
	{ route: '/panel/purchases/deliveries', permissions: [EEmployeePermission.MANAGE_DELIVERIES_AND_RECEIPTS] },
	{ route: '/panel/inbound-buffer', permissions: [EEmployeePermission.MANAGE_DELIVERIES_AND_RECEIPTS] },
	{ route: '/panel/monitoring', permissions: [EEmployeePermission.ADVANCED_MONITORING] },

	// Ustawienia / Pracownicy
	{
		route: '/panel/production-employees/list',
		permissions: [EEmployeePermission.VIEW_PRODUCTION_SIMULATION_TABLET_INSTRUCTIONS],
	},
	{ route: '/panel/employees/list', permissions: [EEmployeePermission.USER_ACCOUNT_MANAGEMENT] },
	{ route: '/panel/production-units', permissions: [EEmployeePermission.MANAGE_FACILITY_ASSIGNMENT_PLAN] },
	{ route: '/panel/warehouse', permissions: [EEmployeePermission.MANAGE_INVENTORY] },
	{ route: '/panel/labels', permissions: [EEmployeePermission.MANAGE_PROMARK_LABELS] },
	{
		route: '/panel/recipe-sockets',
		permissions: [EEmployeePermission.VIEW_SEMI_PRODUCT_SOCKET_ASSIGNMENTS],
	},

	// Tablet
	{
		route: '/panel/tablet/instructions',
		permissions: [EEmployeePermission.VIEW_PRODUCTION_SIMULATION_TABLET_INSTRUCTIONS],
	},
]

// for grouping routes with the same segments e.g. /panel/diets
// to avoid adding permissions to each route
// as to see main route user should have permission to see at least some subroutes
const addMainRoutes = () => {
	const newRoutes: Record<string, EEmployeePermission[]> = {}
	restrictViewRoutes.forEach(route => {
		if (!route.permissions) return
		const splittedRoute = route.route.split('/')
		const segment = splittedRoute?.[2]
		if (!segment || (segment && !splittedRoute[3])) return
		if (!newRoutes[segment]) {
			newRoutes[segment] = [...route.permissions]
		} else {
			newRoutes[segment].push(...route.permissions)
		}
	})
	Object.keys(newRoutes).forEach(key => {
		const uniquePermissions = [...new Set(newRoutes[key])] as EEmployeePermission[]
		restrictViewRoutes.push({ route: `/panel/${key}`, permissions: uniquePermissions })
	})
}
addMainRoutes()

export const isNavMenuRouteMatch = (currentPath: string, menuRoute: string): boolean =>
	currentPath === menuRoute || currentPath.startsWith(`${menuRoute}/`)

// adding order for items and subitems and filtering by permissions
// it have to match route or key
export const navMenuItems = computed(() => {
	const userStore = useUserStore()
	const hasRoutePermission = (route?: string) => {
		const restriction = restrictViewRoutes.find(item => item.route === route)
		return !restriction || userStore.hasPermission(restriction.permissions)
	}

	return navMenuItemsData.value
		.filter(i => {
			if (i.items && !i.route) {
				return i.items.some(item => hasRoutePermission(item.route))
			}

			const commonRoute = restrictViewRoutes.find(obj => obj.route === i.route || obj.route === `/panel/${i.key}`)
			if (commonRoute) {
				return userStore.hasPermission(commonRoute.permissions)
			}
			return true
		})
		.map((item, itemIndex) => {
			const newItem = {
				...item,
				order: itemIndex,
			}

			if (item.items) {
				newItem.items = item.items
					.filter(i => hasRoutePermission(i.route))
					.map((subItem, subItemIndex) => ({
						...subItem,
						order: subItemIndex,
					}))
			}

			return newItem
		})
})
